"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemConfig = require("@/api/system/systemConfig.js");
var COS_DOMAIN = 'https://newsundevia-1257895785.cos.ap-guangzhou.myqcloud.com';

// 模块级缓存，只请求一次
var cosUrlCache = '';
var fetchingPromise = null;
function getCosUrl() {
  if (cosUrlCache) return Promise.resolve(cosUrlCache);
  if (fetchingPromise) return fetchingPromise;
  fetchingPromise = (0, _systemConfig.configInfo)({
    id: 83
  }).then(function (res) {
    cosUrlCache = res && res.txUploadUrl ? res.txUploadUrl.endsWith('/') ? res.txUploadUrl : res.txUploadUrl + '/' : '';
    return cosUrlCache;
  }).catch(function () {
    cosUrlCache = COS_DOMAIN + '/';
    return cosUrlCache;
  });
  return fetchingPromise;
}
var _default = exports.default = {
  created: function created() {
    var _this = this;
    if (!cosUrlCache) {
      getCosUrl().then(function (url) {
        _this._cosUrl = url;
      });
    } else {
      this._cosUrl = cosUrlCache;
    }
  },
  methods: {
    fullUrl: function fullUrl(path) {
      if (!path) return '';
      var match = path.match(/https?:\/\/.+?(https?:\/\/.+)/);
      if (match) path = match[1];
      if (path.startsWith('http')) return path;
      var base = cosUrlCache || COS_DOMAIN + '/';
      if (!base) return path;
      var realPath = path.startsWith('/') ? path.substring(1) : path;
      return base + realPath;
    }
  }
};